
// Prod
export const pnc_url_pnc = 'https://www.infoparcs.fr/pnc/formulaires/api/v3/index.php';

// Dev
/*export const pnc_url_pnc = 'http://vps298004.ovh.net/pnc/api/v3/index.php';*/
